import { Riedl, Tracht } from "../../Utils/GlbLoaderArtefakte.jsx";
import ExperienceModelViewer from "../ExperienceModelViewer.jsx";

export default function ArtefaktBundlesHeimatLandlerMuseum({ currentMuseumId }) {
  const { riedl } = Riedl();
  const { tracht } = Tracht();

  const artefactArray = [riedl, tracht];

  return <ExperienceModelViewer modelArray={artefactArray} currentMuseumId={currentMuseumId} />;
}
